import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { HTML_EDITOR } from "../constants/html-editor.constant";

@Injectable({
  providedIn: "root",
})
export class PrintAPIService {
  getPrintSettings() {
    throw new Error("Method not implemented.");
  }
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
    body: {},
  };

  constructor(private httpClient: HttpClient) {}

  // Updated APIS
  public getPrintablePage(payload: object) {
    return this.httpClient.post(`${HTML_EDITOR.GET_DATA}/`, payload);
  }

  public getSubLetters(letterId: any) {
    return this.httpClient.get(`${HTML_EDITOR.SUB_LETTER_TYPES}/${letterId}`);
  }
  getLetterContent(requestData: any) {
    return this.httpClient.post<{ letterContent: string }>('/register-book-pdf/preview', requestData);
  }  
  public getPrintData(payload){
    return this.httpClient.post(`/register-book-pdf/preview`,{} )
  }
  sendPrintPreview(body: any) {
    return this.httpClient.post('/register-book-pdf/preview', body);
  }
}
